<template>
  <div
    flex="~ col lg:col"
    p-6
    color="grey-600"
    class="flex-1"
    rounded-lg
    border="1px solid grey-200"
  >
    <slot></slot>
  </div>
</template>
